import { useLayoutEffect, useState } from "react"
import { useAppContext } from "../../../contexts/app";
import { ButtonLight } from "../../../components/ctas";
import { PDI } from "../data/pdi"
import { useParams } from "react-router-dom";

const getFormattedDate = () => {
	const now = new Date();
	const formattedDate = now.toISOString().replace(/[-:.]/g, "").slice(0, 15);
	return formattedDate;
};

export const downloadJSONFile = (data, filename = `data_${getFormattedDate()}.json`) => {
	const jsonStr = JSON.stringify(data, null, 2);
	const blob = new Blob([jsonStr], { type: "application/json" });
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}


export const comparePDIToKeys = (formValues, version = 'v2') => {
	let totalItems = 0;
	let missingItems = 0;
	let presentItems = 0;
	let needsToBeCompletedItems = 0;
	const missingKeys = [];
	const needsToBeCompletedKeys = [];
	const recurseSectionsForComparison = (categories) => {
		categories?.forEach(category => {
			category?.sections?.forEach(section => {
				section?.items?.forEach(item => {
					totalItems++;
					// check form fields first
					item?.form?.forEach(formField => {
						totalItems++;
						// Check if field has a value and is not empty
						if (formValues[formField.id] !== undefined && formValues[formField.id] !== null && formValues[formField.id] !== "") {
							presentItems++;
						} else {
							// Field is missing or empty
							missingItems++;
							missingKeys.push(formField.id);
							// console.warn(`Missing form field: ${formField.id}`);
						}
					}
					);
					// Only check item slug (Yes/No checkbox) if hideCheckbox is not true
					if (!item.hideCheckbox) {
						if (formValues[item.slug]) {
							presentItems++;
							if (formValues[item.slug] === "No") {
								needsToBeCompletedItems++;
								needsToBeCompletedKeys.push(item.slug);
							}
						}
						else {
							missingItems++;
							missingKeys.push(item.slug);
							// console.warn(`Missing item: ${item.slug}`);
						}
						if (formValues[`${item.slug}_Details`]) {
							presentItems++;
						}
						else {
							// Details is optional, so don't count it as missing
							// missingItems++;
							// console.warn(`Missing item details: ${item.slug}_Details`);
						}
					}
				}
				);
				if (section?.sections) {
					recurseSectionsForComparison(section.sections);
				}
			}
			);
		}
		);
	}

	// PDI.flockTrailer is an array: [{ v1: [...] }, { v2: [...] }]
	const pdiVersionObj = PDI?.flockTrailer?.find(obj => obj[version]) || PDI?.flockTrailer?.[0];
	const pdiData = pdiVersionObj?.[version] || pdiVersionObj?.v1 || [];
	recurseSectionsForComparison(pdiData);
	// adjust presentItems and missingItems based on needsToBeCompletedItems
	presentItems -= needsToBeCompletedItems;
	missingItems += needsToBeCompletedItems;
	return { unit: formValues.unit_identifiers_unit_identifier_name || "Unit", totalItems, missingItems, presentItems, missingKeys, needsToBeCompletedItems, needsToBeCompletedKeys };
}

// update file name default to be "data_YYYYMMDD_HHMMSS.json"


export const generateReportAsJSON = (formValues, version = 'v2') => {
	const report = [];
	const nowISO = new Date().toISOString();

	const recurseSectionsForReport = (categories) => {
		categories?.forEach(category => {
			category?.sections?.forEach(section => {
				section?.items?.forEach(item => {
					const reportItem = {};
					// handle form fields first
					item?.form?.forEach(formField => {
						if (formValues[formField.id]) {
							reportItem.Type = "Form";
							reportItem.Category = category.category;
							reportItem.Section = section.name;
							reportItem.Item = item.name;
							reportItem.Description = formField.label;
							reportItem.Value = formValues[formField.id];
							// reportItem.CreatedOn = initialLoadValues[`${formField.id}_Timestamp`] || nowISO;
							// reportItem.CreatedBy = initialLoadValues[`${formField.id}_User`] || null;
							reportItem.UpdatedOn = formValues[`${formField.id}_Timestamp`] || nowISO;
							reportItem.UpdatedBy = formValues[`${formField.id}_User`] || null;
						}
					}
					);
					if (formValues[item.slug]) {
						reportItem.Type = "PDI";
						reportItem.Category = category.category;
						reportItem.Section = section.name;
						reportItem.Item = item.name;
						reportItem.Description = item.name;
						reportItem.Value = formValues[item.slug] ? (formValues[item.slug] === "Yes" ? 'Passed' : (formValues[item.slug] === "No" ? 'Failed' : "N/A")) : null;
						// reportItem.CreatedOn = initialLoadValues[`${item.slug}_Timestamp`] || nowISO;
						// reportItem.CreatedBy = initialLoadValues[`${item.slug}_User`] || null;
						reportItem.UpdatedOn = formValues[`${item.slug}_Timestamp`] || nowISO;
						reportItem.UpdatedBy = formValues[`${item.slug}_User`] || null;
					}
					if (formValues[`${item.slug}_Details`]) {
						reportItem.Details = formValues[`${item.slug}_Details`];
						// if Details exist, also add their CreatedOn/By and UpdatedOn/By
						// reportItem.DetailsCreatedOn = initialLoadValues[`${item.slug}_Details_Timestamp`] || nowISO;
						// reportItem.DetailsCreatedBy = initialLoadValues[`${item.slug}_Details_User`] || null;
						reportItem.DetailsUpdatedOn = formValues[`${item.slug}_Details_Timestamp`] || nowISO;
						reportItem.DetailsUpdatedBy = formValues[`${item.slug}_Details_User`] || null;
					}
					// only push if at least Value or Details exist
					if (reportItem.Value || reportItem.Details) {
						report.push(reportItem);
					}
				}
				);
				if (section?.sections) {
					recurseSectionsForReport(section.sections);
				}
			}
			);
		}
		);
	}

	// PDI.flockTrailer is an array: [{ v1: [...] }, { v2: [...] }]
	const pdiVersionObj = PDI?.flockTrailer?.find(obj => obj[version]) || PDI?.flockTrailer?.[0];
	const pdiData = pdiVersionObj?.[version] || pdiVersionObj?.v1 || [];
	recurseSectionsForReport(pdiData);
	return report;
}

// Helper function to get readable name from slug/key
const getReadableNameFromKey = (key, version = 'v2') => {
	let readableName = null;

	// Recursively search through PDI data structure
	const searchPDI = (categories) => {
		categories?.forEach(category => {
			category?.sections?.forEach(section => {
				section?.items?.forEach(item => {
					// Check if this is the item slug we're looking for
					if (item.slug === key) {
						readableName = item.name;
						return;
					}
					// Check form fields
					item?.form?.forEach(formField => {
						if (formField.id === key) {
							readableName = formField.label || formField.id;
							return;
						}
					});
				});
			});
		});
	};

	// PDI.flockTrailer is an array: [{ v1: [...] }, { v2: [...] }]
	const pdiVersionObj = PDI?.flockTrailer?.find(obj => obj[version]) || PDI?.flockTrailer?.[0];
	const pdiData = pdiVersionObj?.[version] || pdiVersionObj?.v1 || [];
	if (pdiData.length > 0) {
		searchPDI(pdiData);
	}

	return readableName || key; // fallback to key if no readable name found
};

// Helper function to check if a unit is completed (based on final signoff)
const isUnitCompleted = (unit) => {
	const signoffUser = unit.final_signoff_user;
	return signoffUser && signoffUser !== '';
};

// Helper function to check if a unit is soaking
const isUnitSoaking = (unit) => {
	const soaking = unit.unit_readiness_documentation_soaking;
	return soaking === 'Yes';
};

export default function FSInventory2() {
	const { loadSheetAsJson } = useAppContext();
	const [units, setUnits] = useState(null);
	const [allUnits, setAllUnits] = useState(null); // Store original unfiltered data
	const [isLoading, setIsLoading] = useState(false);
	const [expandedUnits, setExpandedUnits] = useState({});
	const [activeSort, setActiveSort] = useState(null);
	const [showCompleted, setShowCompleted] = useState(false); // Default to hiding completed units
	const [onlyShowSoaking, setOnlyShowSoaking] = useState(false); // Default to showing all units

	const params = useParams();
	const paramVersion = params.version || 'v2'; // Default to v1 if not specified



	useLayoutEffect(() => {
		setIsLoading(true);
		const rows = loadSheetAsJson();
		rows.then((rows) => {
			setUnits(rows);
			setAllUnits(rows); // Store original data
		}).finally(() => {
			setIsLoading(false);
		});

		/* Examples of loading sheets: */
		/*
		const rows = loadSheetAsJson(); // loads and returns rows
		rows.then((rows) => {
			console.log('Loaded rows:', rows);

			switchSpreadsheet('1UJH-oDzCpk4NDjI9FOL-JfONhfOfv1dL5LU0WCq2p-o', { preload: true, force: true, clearCache: true });
			const moreRows = loadSheetAsJson(); // loads and returns rows
			moreRows.then((rows) => {
				console.log('Loaded rows:', rows);

				// test of multiple sheets load:
				const ids = [
					"1BM7hwb7efeXT_96D-VMh4uhSP6jH83B7oGKhBmAKrJo",
					"1VXcYfL6ymiyDCSIsQPMtLTQwuW_m7ndU8yrZWxQe1nM"
				];
				// results: [{ spreadsheetId: 'sheetId_AAAAA', data: [...], cached: boolean }, ...]
				// const results = loadSheetsBatchAsJson(ids, { force: false, trim: true, restore: true }).then((results) => {
				const results = loadSheetsBatchAsJson(ids, { map: "json" }).then((results) => {
					console.log("Multiple sheets loaded:", results);
					const firstObject = results[0]?.data;
					console.log('firstObject', firstObject);
				});

			});
		});
		*/

	}, []);

		/* Load initial values from sheet - to make spreadsheet headers: */
	// useLayoutEffect(() => {
	// 	if (PDI) {
	// 		console.clear();
	// 		console.log(extractSlugsAndCreateFields(PDI?.flockTrailer?.v1));
	// 	}
	// }, [PDI]);



	return <>
		<div className="tw-w-full">
			{/* Loading Overlay */}
			{isLoading && (
				<div className="tw-fixed tw-inset-0 tw-bg-black/80 tw-z-[100] tw-flex tw-items-center tw-justify-center tw-backdrop-blur-sm">
					<div className="tw-bg-white tw-rounded-6px tw-p-40px tw-shadow-2xl tw-flex tw-flex-col tw-items-center tw-gap-20px">
						<div className="tw-w-60px tw-h-60px tw-border-4px tw-border-solid tw-border-white/20 tw-border-t-secondary tw-rounded-full tw-animate-spin"></div>
						<div className="tw-text-secondary tw-font-secondary-bold tw-text-xl tw-uppercase tw-tracking-widest">
							Loading...
						</div>
					</div>
				</div>
			)}

			<h1 className="tw-text-3xl tw-font-secondary-bold tw-tracking-widest tw-text-white tw-px-10px tw-text-center tw-py-20px tw-leading-none tw-uppercase tw-mb-20d">
				Flock Units
			</h1>
			<div>
				<form className="tw-m-0px tw-px-0px tw-pt-0px tw-pb-20px" onSubmit={(e) => {
					e.preventDefault();
					return false;
				}}>
					<input type="text" name="search" id="search" className="tw-outline-none tw-w-full tw-bg-black tw-border tw-border-white/20 tw-rounded tw-p-10px tw-text-white tw-mb-20px" placeholder="Search by Name, VIN, or UUID" onChange={(e) => {
						const val = e.target.value.toLowerCase();
						if (!val || val === '') {
							setUnits(allUnits);
							return;
						}
						const filtered = (allUnits || []).filter((unit) => {
							return (unit.unit_identifiers_unit_identifier_name && unit.unit_identifiers_unit_identifier_name.toLowerCase().includes(val)) ||
								(unit.VIN && unit.VIN.toLowerCase().includes(val)) ||
								(unit.UUID && unit.UUID.toLowerCase().includes(val));
						});
						setUnits(filtered);
					}} />
					<button type="submit" className="tw-hidden" />
				</form>
			</div>
			<div>
				{units && units.length > 0 && (() => {
					const displayedUnits = units.filter(unit => {
						const shouldShowCompleted = showCompleted || !isUnitCompleted(unit);
						const shouldShowSoaking = onlyShowSoaking ? isUnitSoaking(unit) : true;
						return shouldShowCompleted && shouldShowSoaking;
					});
					const displayedCount = displayedUnits.length;
					return <div className="tw-text-white tw-font-quaternary-lite tw-text-[.9em] tw-mb-10px tw-text-center">
						{displayedCount} {displayedCount === 1 ? "unit" : "units"} found.
					</div>
				})()}
				{units && units.length > 20 && <div className="tw-text-white tw-font-quaternary-lite tw-text-[.9em] tw-mb-10px tw-text-center">
					Tip: Use the search box above to filter results.
				</div>}
				{units && units.length > 0 && <div className="tw-text-white tw-font-quaternary-lite tw-text-[.9em] tw-mb-10px tw-text-center">
					Color Key: <span className="tw-text-green-500">Green = Complete</span>, <span className="tw-text-yellow-500">Yellow = Needs Attention</span>, <span className="tw-text-red-500">Red = Incomplete</span>
				</div>}
				<div className="tw-text-center tw-uppercase">
					Sort:
				</div>
				<div className="u-scrollbar tw-py-10px [&_.c-button-filter_span]:tw-flex [&_.c-button-filter_span]:tw-items-center [&_.c-button-filter_span]:tw-justify-center [&_.c-button-filter]:tw-cursor-pointer tw-leading-none  [&_.c-button-filter]:tw-min-h-30px [&_.c-button-filter]:tw-min-w-150px [&_.c-button-filter_span]:tw-w-full tw-text-center tw-uppercase tw-w-full tw-overflow-x-auto tw-snap-x tw-snap-end tw-snap-proximity tw-flex tw-gap-10px tw-flex-nowrap tw-whitespace-nowrap tw-px-10px tw-border-x-1px tw-border-white/10 tw-justify-start">

					{/* Unit Number Button - Cycles through: null → unit-number → unit-number-reverse → null */}
					<ButtonLight className={`tw-min-h-30px [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${(activeSort === 'unit-number' || activeSort === 'unit-number-reverse') ? '!tw-bg-primary !tw-text-black' : ''}`} onClick={(e) => {
						e.preventDefault();
						if (activeSort === 'unit-number') {
							// Second click: apply reverse sort
							const sorted = (units || []).sort((a, b) => {
								const unitNumber = (a.unit_identifiers_unit_identifier_name || '').replaceAll("Flock Trailer ", "");
								const unitNumberB = (b.unit_identifiers_unit_identifier_name || '').replaceAll("Flock Trailer ", "");
								return parseInt(unitNumberB) - parseInt(unitNumber);
							});
							setUnits([...sorted]);
							setActiveSort('unit-number-reverse');
						} else if (activeSort === 'unit-number-reverse') {
							// Third click: turn off filter
							setActiveSort(null);
							setIsLoading(true);
							const rows = loadSheetAsJson();
							rows.then((rows) => {
								setUnits(rows);
							}).finally(() => {
								setIsLoading(false);
							});
						} else {
							// First click: apply ascending sort
							const sorted = (units || []).sort((a, b) => {
								const unitNumber = (a.unit_identifiers_unit_identifier_name || '').replaceAll("Flock Trailer ", "");
								const unitNumberB = (b.unit_identifiers_unit_identifier_name || '').replaceAll("Flock Trailer ", "");
								return parseInt(unitNumber) - parseInt(unitNumberB);
							});
							setUnits([...sorted]);
							setActiveSort('unit-number');
						}
					}}>
						<span className="tw-text-[.5em]">
							{activeSort === 'unit-number-reverse' ? 'Unit Number (Reverse)' : 'Unit Number'}
						</span>
					</ButtonLight>

					{/* Latest/Oldest Button - Cycles through: null → latest → oldest → null */}
					<ButtonLight className={`tw-min-h-30px [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${(activeSort === 'latest' || activeSort === 'oldest') ? '!tw-bg-primary !tw-text-black' : ''}`} onClick={(e) => {
						e.preventDefault();
						if (activeSort === 'latest') {
							// Second click: apply oldest sort
							const sorted = (units || []).sort((a, b) => {
								const dateA = new Date(a["Updated On"] || a["Created On"] || 0);
								const dateB = new Date(b["Updated On"] || b["Created On"] || 0);
								return dateA - dateB;
							});
							setUnits([...sorted]);
							setActiveSort('oldest');
						} else if (activeSort === 'oldest') {
							// Third click: turn off filter
							setActiveSort(null);
							setIsLoading(true);
							const rows = loadSheetAsJson();
							rows.then((rows) => {
								setUnits(rows);
							}).finally(() => {
								setIsLoading(false);
							});
						} else {
							// First click: apply latest sort
							const sorted = (units || []).sort((a, b) => {
								const dateA = new Date(a["Updated On"] || a["Created On"] || 0);
								const dateB = new Date(b["Updated On"] || b["Created On"] || 0);
								return dateB - dateA;
							});
							setUnits([...sorted]);
							setActiveSort('latest');
						}
					}}>
						<span className="tw-text-[.5em]">
							{activeSort === 'oldest' ? 'Oldest' : 'Latest'}
						</span>
					</ButtonLight>
					{/* <ButtonLight className="c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center"  onClick={(e) => {
						e.preventDefault();
						const sorted = (units || []).sort((a, b) => {
							const nameA = a.unit_identifiers_unit_identifier_name || '';
							const nameB = b.unit_identifiers_unit_identifier_name || '';
							return nameA.localeCompare(nameB);
						}
						);
						setUnits([...sorted]);
					}
					}>
						Name A-Z
					</ButtonLight>
					<ButtonLight className="c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center"  onClick={(e) => {
						e.preventDefault();
						const sorted = (units || []).sort((a, b) => {
							const nameA = a.unit_identifiers_unit_identifier_name || '';
							const nameB = b.unit_identifiers_unit_identifier_name || '';
							return nameB.localeCompare(nameA);
						}
						);
						setUnits([...sorted]);
					}
					}>
						Name A-Z
					</ButtonLight>
					<ButtonLight className="c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center"  onClick={(e) => {
						e.preventDefault();
						const sorted = (units || []).sort((a, b) => {
							const nameA = a.unit_identifiers_unit_identifier_name || '';
							const nameB = b.unit_identifiers_unit_identifier_name || '';
							return nameB.localeCompare(nameA);
						}
						);
						setUnits([...sorted]);
					}
					}>
						Name Z-A
					</ButtonLight>*/}
					{/* VIN Button - Cycles through: null → vin-az → vin-za → null */}
					<ButtonLight className={`tw-min-h-30px [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${(activeSort === 'vin-az' || activeSort === 'vin-za') ? '!tw-bg-primary !tw-text-black' : ''}`} onClick={(e) => {
						e.preventDefault();
						if (activeSort === 'vin-az') {
							// Second click: apply Z-A sort
							const sorted = (units || []).sort((a, b) => {
								const vinA = a.VIN || '';
								const vinB = b.VIN || '';
								return vinB.localeCompare(vinA);
							});
							setUnits([...sorted]);
							setActiveSort('vin-za');
						} else if (activeSort === 'vin-za') {
							// Third click: turn off filter
							setActiveSort(null);
							setIsLoading(true);
							const rows = loadSheetAsJson();
							rows.then((rows) => {
								setUnits(rows);
							}).finally(() => {
								setIsLoading(false);
							});
						} else {
							// First click: apply A-Z sort
							const sorted = (units || []).sort((a, b) => {
								const vinA = a.VIN || '';
								const vinB = b.VIN || '';
								return vinA.localeCompare(vinB);
							});
							setUnits([...sorted]);
							setActiveSort('vin-az');
						}
					}}>
						<span className="tw-text-[.5em]">
							{activeSort === 'vin-za' ? 'VIN Z-A' : 'VIN A-Z'}
						</span>
					</ButtonLight>

					{/* Status Button - Cycles through: null → status → status-reverse → null */}
					<ButtonLight className={`tw-min-h-30px [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center c-button-filter tw-w-full tw-flex tw-justify-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${(activeSort === 'status' || activeSort === 'status-reverse') ? '!tw-bg-primary !tw-text-black' : ''}`} onClick={(e) => {
						e.preventDefault();
						if (activeSort === 'status') {
							// Second click: apply reverse status sort
							const sorted = (units || []).sort((a, b) => {
								const statusA = comparePDIToKeys(a, paramVersion);
								const statusB = comparePDIToKeys(b, paramVersion);
								// sort by missingItems descending (most missing first), then by needsToBeCompletedItems descending, then by presentItems ascending
								if (statusA.missingItems !== statusB.missingItems) {
									return statusB.missingItems - statusA.missingItems;
								}
								if (statusA.needsToBeCompletedItems !== statusB.needsToBeCompletedItems) {
									return statusB.needsToBeCompletedItems - statusA.needsToBeCompletedItems;
								}
								return statusA.presentItems - statusB.presentItems;
							});
							setUnits([...sorted]);
							setActiveSort('status-reverse');
						} else if (activeSort === 'status-reverse') {
							// Third click: turn off filter
							setActiveSort(null);
							setIsLoading(true);
							const rows = loadSheetAsJson();
							rows.then((rows) => {
								setUnits(rows);
							}).finally(() => {
								setIsLoading(false);
							});
						} else {
							// First click: apply status sort
							const sorted = (units || []).sort((a, b) => {
								const statusA = comparePDIToKeys(a, paramVersion);
								const statusB = comparePDIToKeys(b, paramVersion);
								// sort by missingItems ascending (least missing first), then by needsToBeCompletedItems ascending, then by presentItems descending
								if (statusA.missingItems !== statusB.missingItems) {
									return statusA.missingItems - statusB.missingItems;
								}
								if (statusA.needsToBeCompletedItems !== statusB.needsToBeCompletedItems) {
									return statusA.needsToBeCompletedItems - statusB.needsToBeCompletedItems;
								}
								return statusB.presentItems - statusA.presentItems;
							});
							setUnits([...sorted]);
							setActiveSort('status');
						}
					}}>
						<span className="tw-text-[.5em]">
							{activeSort === 'status-reverse' ? 'Status (Reverse)' : 'Status'}
						</span>
					</ButtonLight>

				</div>
			</div>
			<div className="tw-mt-10px md:tw-mt-0px tw-mb-20px tw-flex tw-flex-wrap tw-justify-center tw-gap-10px">
				<ButtonLight
					className={`c-button-filter tw-min-w-200px tw-flex tw-leading-none tw-justify-center [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${showCompleted ? '!tw-bg-primary !tw-text-black' : ''}`}
					onClick={(e) => {
						e.preventDefault();
						setShowCompleted(!showCompleted);
					}}
				>
					<span className="tw-text-[.5em] tw-uppercase tw-inline-flex tw-items-center tw-justify-center tw-min-h-30px">Show Completed Units</span>
				</ButtonLight>
				<ButtonLight
					className={`c-button-filter tw-min-w-200px tw-flex tw-leading-none tw-justify-center [&_span]:tw-inline-flex [&_span]:tw-justify-center [&_span]:tw-items-center tw-items-center hover:!tw-bg-[#fdf0a9] hover:!tw-text-black ${onlyShowSoaking ? '!tw-bg-primary !tw-text-black' : ''}`}
					onClick={(e) => {
						e.preventDefault();
						setOnlyShowSoaking(!onlyShowSoaking);
					}}
				>
					<span className="tw-text-[.5em] tw-uppercase tw-inline-flex tw-items-center tw-justify-center tw-min-h-30px">Only Show Soaking Units</span>
				</ButtonLight>
			</div>
			<div className="tw-space-y-20px tw-pb-40px">
				{units && units.length > 0 ? <>
					{units.filter(unit => {
						const shouldShowCompleted = showCompleted || !isUnitCompleted(unit);
						const shouldShowSoaking = onlyShowSoaking ? isUnitSoaking(unit) : true;
						return shouldShowCompleted && shouldShowSoaking;
					}).map((unit, idx) => {

						const statusOfUnit = comparePDIToKeys(unit, paramVersion);
						const isSoaking = unit.unit_readiness_documentation_soaking === 'Yes' ? true : null;
						const isShipped = unit.logistics_shipping_information_shipping_date_shipping_date ? true : null;
						const isComplete = (unit.final_signoff_user && unit.final_signoff_user !== '') ? true : null;

						const today = new Date();

						// Determine shipping status by comparing dates only (ignoring time)
						let isShippedDatePassed = null;
						if (unit.logistics_shipping_information_shipping_date_shipping_date) {
							// Parse date string as local time to avoid timezone issues
							// Expected format: YYYY-MM-DD
							const dateStr = unit.logistics_shipping_information_shipping_date_shipping_date;
							const [year, month, day] = dateStr.split('-').map(Number);
							const shipDateOnly = new Date(year, month - 1, day); // month is 0-indexed
							const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

							if (shipDateOnly.getTime() === todayDateOnly.getTime()) {
								isShippedDatePassed = "Shipping Today";
							} else if (shipDateOnly > todayDateOnly) {
								isShippedDatePassed = "Ready to Ship";
							} else {
								isShippedDatePassed = "Shipped";
							}
						}


						// convert YYYY-MM-DD that's in a string to a date in MM/DD/YYYY format

						// if (unit.unit_identifiers_unit_identifier_name === "Flock Trailer 25592263") console.log('statusOfUnit ' + unit.unit_identifiers_unit_identifier_name, statusOfUnit);

						return <div key={idx} className="tw-flex tw-leading-none tw-overflow-clip tw-font-quaternary tw-font-quaternary-thin tw-flex-col tw-border tw-border-white/20 tw-rounded tw-bg-black tw-px-20px tw-pb-20px  tw-invert-0 hover:tw-bg-white/15">
							<div className={`${ isSoaking || isShipped || isComplete ? 'tw-bg-white/8 tw-border-b-1px tw-border-b-white/5 ' : ''} tw-mb-5px tw-h-15px tw-pt-2px tw-flex tw-items-center -tw-mx-20px tw-justify-center tw-text-center tw-leading-none tw-font-secondary-bold tw-text-[.5em] tw-uppercase tw-tracking-widest`}>
								{ isShipped ? isShippedDatePassed : (isComplete ? 'PDI COMPLETE' : (isSoaking ? 'Soaking' : '')) }
							</div>
							<div className="tw-font-bold tw-text-[1.5em] tw-mb-5p">&quot;<span className="tw-uppercase">{unit.unit_identifiers_unit_identifier_name || 'No Name'}&quot; Trailer</span></div>
							<div className="tw-opacity-80 tw-mb-10p">VIN: <span className="tw-font-code tw-normal-case tw-text-[.95em] tw-font-bold">{unit.VIN || 'N/A'}</span></div>
							<div className="tw-w-full tw-bg-white/5 tw-w-full tw-h-5px tw-border tw-border-white/20 tw-rounded-full tw-relative tw-overflow-clip">
								<div className={`
								${isUnitCompleted(unit) ? 'tw-bg-green-500' : (statusOfUnit.missingKeys?.length === 0) ? 'tw-bg-green-500' : (statusOfUnit.missingItems === 0 ? 'tw-bg-yellow-500' : 'tw-bg-red-500')}
								tw-h-5px tw-absolute tw-left-0px tw-top-0px tw-bottom-0px`} style={{ width: (isUnitCompleted(unit) || statusOfUnit.missingItems === 0) ? '100%' : `${((statusOfUnit.presentItems / statusOfUnit.totalItems) * 100).toFixed(2)}%` }}></div>
							</div>
							<div className="tw-mt-10px tw-uppercase tw-space-y-10p">
								<div>Company: {unit["Company"] || 'N/A'}</div>
								<div className="tw-text-[.9em]">Version: <span className="tw-font-code tw-normal-case tw-text-[.95em]">{unit["unit_identifiers_make_unit_version"] || 'N/A'}</span> | UUID: <span className="tw-font-code tw-normal-case tw-text-[.95em]">{unit["UUID"] || 'N/A'}</span></div>
								{unit?.victron_vrm_link && <>
									<div className="tw-text-[.9em]">
										VRM: <a href={unit?.victron_vrm_link} target="_blank" rel="noopener noreferrer" className="hover:tw-underline tw-no-underline">
											Visit
										</a>
									</div>
								</>}
								<div>
									Unit Number: {unit["unit_identifiers_unit_identifier_name"]?.replaceAll("Flock Trailer ", "") || 'N/A'} | Model: {unit.unit_identifiers_unit_model || 'N/A'}
								</div>
								{unit.logistics_shipping_information_shipping_date_shipping_date && <div className="tw-text-[.9em]">
									Ship Date: { unit.logistics_shipping_information_shipping_date_shipping_date }
								</div>}
								<div className="tw-text-[.9em]">Last Updated: {unit["Updated On"] && new Date(unit["Updated On"]).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }) || 'N/A'} by {unit["Updated By"] || 'N/A'}</div>
								<div className="tw-text-[.9em]">Created On: {unit["Created On"] && new Date(unit["Created On"]).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }) || 'N/A'} by {unit["Created By"] || 'N/A'}</div>
								{statusOfUnit.missingItems !== 0 && (
									<div>
										<div
											className="tw-text-[.9em] tw-cursor-pointer hover:tw-opacity-80"
											onClick={() => {
												setExpandedUnits(prev => ({
													...prev,
													[unit.UUID]: !prev[unit.UUID]
												}));
											}}
										>
											<span className="tw-mr-5px">{expandedUnits[unit.UUID] ? '▼' : '▶'}</span>
											Items to Complete: <span className="tw-font-bold">{statusOfUnit.missingItems - statusOfUnit?.missingKeys?.length} &quot;Not Passed&quot; <span className="tw-font-quaternary-lite">( <span className="tw-font-bold">{statusOfUnit?.missingKeys?.length} Not Started</span> )</span></span>
										</div>

										{expandedUnits[unit.UUID] && (
											<div className="tw-ml-20px tw-mt-5px tw-space-y-5px tw-text-[0.85em] tw-normal-case">
												{statusOfUnit?.needsToBeCompletedKeys?.length > 0 && (
													<div>
														<div className="tw-font-bold tw-text-red-400 tw-mb-3px">Not Passed:</div>
														<ul className="tw-list-disc tw-ml-20px tw-space-y-2px">
															{statusOfUnit.needsToBeCompletedKeys.slice(0, 10).map((key, i) => (
																<li key={i} className="tw-opacity-90">
																	{getReadableNameFromKey(key, paramVersion)}
																</li>
															))}
															{statusOfUnit.needsToBeCompletedKeys.length > 10 && (
																<li className="tw-opacity-70 tw-italic">
																	... {statusOfUnit.needsToBeCompletedKeys.length - 10} more items hidden
																</li>
															)}
														</ul>
													</div>
												)}
												{statusOfUnit?.missingKeys?.length > 0 && (
													<div>
														<div className="tw-font-bold tw-text-yellow-400 tw-mb-3px tw-mt-5px">Not Started:</div>
														<ul className="tw-list-disc tw-ml-20px tw-space-y-2px">
															{statusOfUnit.missingKeys.slice(0, 10).map((key, i) => (
																<li key={i} className="tw-opacity-90">
																	{getReadableNameFromKey(key, paramVersion)}
																</li>
															))}
															{statusOfUnit.missingKeys.length > 10 && (
																<li className="tw-opacity-70 tw-italic">
																	... {statusOfUnit.missingKeys.length - 10} more items hidden
																</li>
															)}
														</ul>
													</div>
												)}
											</div>
										)}
									</div>
								)}
							</div>
							<div className="tw-flex tw-w-full tw-justify-between tw-mt-10px tw-pt-10px tw-gap-10px tw-border-t tw-border-white/20">
								<ButtonLight default className="tw-min-h-40px tw-min-w-0px tw-basis-1/3  md:tw-min-w-[7.8125em]" title="Download JSON" onClick={(e) => {
									e.preventDefault();
									downloadJSONFile(generateReportAsJSON(unit, paramVersion), `RVMP-Flex-Security_${unit.unit_identifiers_unit_model ? unit.unit_identifiers_unit_model.replaceAll(" ", "-").toUpperCase() : ""}_${unit.Company ? unit.Company.replaceAll(" ", "-") : ""}_${unit.unit_identifiers_unit_identifier_name ? unit.unit_identifiers_unit_identifier_name.replaceAll(" ", "-").toUpperCase() : ""}_${unit["Updated On"] ? new Date(unit["Updated On"]).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replaceAll(" ", "_").replaceAll(",", "_") : ""}.json`);
								}}>
									JSON
								</ButtonLight>

								<ButtonLight default className="tw-min-h-40px tw-min-w-0px tw-basis-1/3  md:tw-min-w-[7.8125em]" href={`/fs/flock/pdf/${unit.UUID}/${unit.Version}`} title="Print PDF" target="_blank">
									PDF
								</ButtonLight>

								<ButtonLight default className="tw-min-h-40px tw-min-w-0px tw-basis-1/3 md:tw-min-w-[7.8125em]" href={`/fs/flock-edit/${unit.UUID}/${unit.Version}`} title="Edit unit">
									View
								</ButtonLight>
							</div>
						</div>
					}
					)}
				</> : <> No Results </>}
			</div>
		</div>
	</>
}
